'use es6';

export const getEmailVerificationEndpoint = userId => `email-verification/v1/users/${userId}/verifications`;